
<div [hidden]="isReviewing">
    <form #f="ngForm" (ngSubmit)="reviewMessage()">
        <div class="p-grid">
            <div class="p-col-12 error-notify-text">
                <app-validateform [formToValidate]="addMessageForm"></app-validateform>
            </div>            
        </div>
        <div class="p-grid">
            <div class="p-col-12 page-header">New Message</div>
            <div class="p-col-12 divider-header">
                <p-divider></p-divider>
            </div>
            <div class="p-col-12">
                <div class="p-grid">
                    <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                        <button pButton type="submit" class="fullwidthbtn" label="Review"></button>
                    </div>
                    <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                        <button pButton type="button" class="fullwidthbtn" label="Cancel" (click)="cancelAddMessage()"></button>
                    </div>
                </div>
                <div>
                    <p-panel header="CONTACT INFORMATION">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="message.ContactName"
                                           name="ContactName"
                                           requiredNoSpaceValidator
                                           data-display-name="ContactName" />
                                    <label for="float-input">Contact Name*</label>
                                </span>
                            </div>

                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="message.ContactPhone"
                                           name="ContactPhone"
                                           requiredNoSpaceValidator
                                           data-display-name="ContactPhone" />
                                    <label for="float-input">Contact Phone*</label>
                                </span>
                            </div>

                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="message.ContactEmail"
                                           name="ContactEmail"
                                           requiredNoSpaceValidator
                                           data-display-name="ContactEmail" />
                                    <label for="float-input">Contact Email*</label>
                                </span>
                            </div>

                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="message.AdminEmail"
                                           name="AdminEmail" />
                                    <label for="float-input">Admin Email</label>
                                </span>
                            </div>
                        </div>
                    </p-panel>
                    <p-panel header="OPPORTUNITY LOCATION">
                        <div class="p-grid">
                            <div class="p-col-12">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="countryOptions"
                                                [(ngModel)]="message.CountryID"
                                                name="Country"
                                                (onChange)="onCountryChange()">
                                    </p-dropdown>
                                    <label for="dropdown">Country</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="stateOptions"
                                                [(ngModel)]="message.StateID"
                                                name="State">
                                    </p-dropdown>
                                    <label for="dropdown">State</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="message.City"
                                           name="City" />
                                    <label for="p-float-label">City</label>
                                </span>
                            </div>
                        </div>
                    </p-panel>
                    <p-panel header="DEAL & PROPERTY TYPE">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="dealTypeOptions"
                                                [(ngModel)]="message.DealTypeID"
                                                name="DealType"
                                                required
                                                data-display-name="Deal Type">
                                    </p-dropdown>
                                    <label for="dropdown">Deal Type*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="propertyTypeOptions"
                                                [(ngModel)]="message.PropertyTypeID"
                                                name="PropertyType"
                                                required
                                                data-display-name="Property Type">
                                    </p-dropdown>
                                    <label for="dropdown">Property Type*</label>
                                </span>
                            </div>
                        </div>
                    </p-panel>
                    <p-panel header="MESSAGE">
                        <div class="p-grid">
                            <div class="p-col-12">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="message.HeadLine"
                                           name="Subject"
                                           requiredNoSpaceValidator
                                           data-display-name="Subject" />
                                    <label for="float-input">Subject*</label>
                                </span>
                            </div>
                            <div class="p-col-12">
                                <p-editor placeholder="Body"
                                          [(ngModel)]="message.BroadcastBody"
                                          [style]="{'height':'320px'}"
                                          name="Body"></p-editor>
                            </div>
                        </div>
                    </p-panel>
                    <p-panel header="ATTACHMENTS">
                        <div class="p-grid">
                            <div class="p-col-12">
                                <p-fileUpload name="myfile[]"
                                              url="{{uploadURL}}"
                                              multiple="multiple"
                                              chooseLabel="Add Files"
                                              [showUploadButton]="false"
                                              (onBeforeUpload)="onBeforeUpload($event)"
                                              (onUpload)="onUploadCompleted($event)">
                                </p-fileUpload>
                            </div>
                        </div>
                    </p-panel>
                </div>
            </div>
        </div>
    </form>
</div>
<div [hidden]="!isReviewing">
    <app-message-review [message]="message" (reviewBackToEdit)="onReviewBackToEdit()" (reviewCompletedAndSubmit)="onReviewCompletedAndSubmit()"></app-message-review>
</div>

<p-confirmDialog header="Confirmation" key="AddMessageConfirmDialog" icon="pi pi-exclamation-triangle"></p-confirmDialog>


